var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.6512 110.764c-2.442-9.4314-2.7893-20.6103-9.4315-31.0836-6.6313-10.4734-11.0486-8.726-17.1155-8.726h-29.6836v76.4719h-10.8315v-8.5958H4.3815v34.307h16.6923c0-15.2813 12.3835-27.6648 27.6649-27.6648 15.2813 0 27.6648 12.3835 27.6648 27.6648H162.6v-8.8453h10.8316v8.8453h11.1028c0-15.2813 12.3835-27.871 27.6649-27.871s27.6649 12.3835 27.6649 27.6648h.9768s10.126 0 10.126-8.0314v-31.431c0-9.084-10.8315-14.6735-21.3048-22.7049h-.0109z",
    fill: "#ff0a21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.349 56.1397h155.5593v69.9165H4.349V56.1397z",
    fill: "#f00229"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7061 153.6451c-10.7664 0-19.4924 8.726-19.4924 19.4924 0 10.7664 8.726 19.4925 19.4924 19.4925 10.7664 0 19.4924-8.726 19.4924-19.4925 0-10.7664-8.726-19.4924-19.4924-19.4924z",
    fill: "#ec010b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M229.6512 110.764c-2.442-9.4314-2.7893-20.6103-9.4315-31.0836-6.6313-10.4734-11.0486-8.726-17.1155-8.726h-29.6836v76.4719h-10.8315v-8.5958H4.3815v34.307h16.6923c0-15.2813 12.3835-27.6648 27.6649-27.6648 15.2813 0 27.6648 12.3835 27.6648 27.6648H162.6v-8.8453h10.8316v8.8453h11.1028c0-15.2813 12.3835-27.871 27.6649-27.871s27.6649 12.3835 27.6649 27.6648h.9768s10.126 0 10.126-8.0314v-31.431c0-9.084-10.8315-14.6735-21.3048-22.7049h-.0109z",
    fill: "#f00429"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.1558 153.439c-10.7664 0-19.4924 8.726-19.4924 19.4815s8.726 19.4924 19.4924 19.4924c10.7664 0 19.4924-8.726 19.4924-19.4924 0-10.7664-8.726-19.4816-19.4924-19.4816z",
    fill: "#ee030d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourier);
export default __webpack_public_path__ + "static/media/courier.ffaae445d8a1a01c09ec43418c8b97e3.svg";
export { ForwardRef as ReactComponent };